import React, { useEffect } from 'react';
import { usePanelContext } from './PanelContext'; // Import the context
import './Panel.css';
import { useStrings } from '../StringsContext';

// Panels that fly in from the RIGHT edge on desktop (docs/ui-conventions.md). Phones keep every
// panel on the left: mobile.css overrides the class.
const RIGHT_PANELS = new Set(['HowToPanel', 'SeasonPanel', 'LeaderboardPanel']);

const Panel = ({ onClose, children, descriptionKey, panelName, titleKey, title }) => {
  const strings = useStrings();
  const { activePanel, openPanel, closePanel } = usePanelContext();

  useEffect(() => {
    if (activePanel === panelName) {
      openPanel(panelName); // Set this panel as active
    }
  }, [activePanel, panelName, openPanel]);

  if (activePanel !== panelName) {
    return null; // Ensure only the active panel is displayed
  }

  return (
    <div className={`panel-container${RIGHT_PANELS.has(panelName) ? ' panel-container--right' : ''}`} data-panel-name={panelName}>
      {/* Fixed Header with Title and Close Button */}
      <div className="panel-header">
        <h2 className="panel-title">{title || strings[titleKey] || "Panel"}</h2>
        <button
          className="panel-close-btn"
          onClick={() => {
            closePanel();
            onClose();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            width="24"
            height="24"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      {/* Scrollable Content Area */}
      <div className="panel-content">{children}</div>

      {/* Panel Description */}
      {descriptionKey && (
        <div className="panel-description">
          <p>{strings[descriptionKey]}</p>
        </div>
      )}
      
      {/* Buffer space for Ko-fi widget */}
      <div className="panel-buffer-space"></div>
    </div>
  );
};

export default Panel;